import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const ThankYou = () => (
  <main style={{ minHeight: '100vh', background: '#0a0f1e', display: 'flex', alignItems: 'center' }}>
    <section style={{ width: '100%', padding: 'clamp(96px, 14vw, 140px) 0' }}>
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          className="glass-card"
          style={{ padding: 'clamp(24px, 5vw, 48px)', textAlign: 'center' }}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div
            style={{
              width: '72px',
              height: '72px',
              borderRadius: '50%',
              background: 'rgba(0,212,170,0.1)',
              border: '2px solid rgba(0,212,170,0.35)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              color: '#00d4aa',
            }}
          >
            <CheckCircle size={34} />
          </div>
          <h1 style={{ fontFamily: 'Manrope', fontWeight: 800, fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', color: '#fff', letterSpacing: '-0.02em', marginBottom: '12px' }}>
            You are in
          </h1>
          <p style={{ color: '#94a3b8', fontFamily: 'Inter', fontSize: '1rem', lineHeight: 1.75, marginBottom: '28px' }}>
            We received your message and we will connect with you within 24 hours.
          </p>
          <Link to="/" className="btn-primary">
            Back to Home
          </Link>
        </motion.div>
      </div>
    </section>
  </main>
);

export default ThankYou;
